import { render, staticRenderFns } from "./review-grid-04.vue?vue&type=template&id=0b4fc588&scoped=true&"
import script from "./review-grid-04.vue?vue&type=script&lang=js&"
export * from "./review-grid-04.vue?vue&type=script&lang=js&"
import style0 from "./review-grid-04.vue?vue&type=style&index=0&id=0b4fc588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4fc588",
  null
  
)

export default component.exports